import { Firestore } from "../lib/firebase";

const secondQuery = text => {
    const lastLetter = String.fromCharCode(text.charCodeAt(text.length - 1) + 1);
    const query = text.slice(0, -1) + lastLetter;
    return query;
}

export const create = async (payload) => {
    try {
        await Firestore.collection("models")
            .doc(payload.SKU)
            .set(payload);
    } catch (error) {
        return error;
    }
};

export const update = async (payload) => {
    const model = await getSKU(payload.SKU);
    const doc = Firestore.collection("models")
        .doc(model.SKU);

    try {
        doc.set(payload, { merge: true });
    } catch (error) {
        return error;
    }
};

export const getSKU = async (SKU) => {
    try {
        const model = await Firestore.collection("models")
            .doc(SKU).get();
        return model.data();
    } catch (error) {
        return error;
    }
};

export const getModelsByQuery = async ({ field, search, itemsPerPage }) => {
    const query = search.charAt(0).toUpperCase() + search.slice(1);
    const secondary = secondQuery(query);
    const codeCollection = Firestore.collection("models")
        .where('SKU', '>=', query)
        .where('SKU', '<', secondary)
        .limit(itemsPerPage);
    try {
        const snapshot = await codeCollection.get();
        const tasks = snapshot.docs.map(codeDoc => getSKU(codeDoc.id));
        const codes = Promise.all(tasks);
        return codes;
    } catch (error) {
        throw error;
    }
};
